/* 🤖 this file was generated by svg-to-ts */
export const kzIconsFilter: {
  name: 'filter';
  data: string;
} = {
  name: 'filter',
  data: `<svg fill="none" viewBox="0 0 22 20"><path d="M21 1H1l8 9.46V17l4 2v-8.54L21 1Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`
};
